import helpers from '../../util/helpers';

const searchRegions = () => {
  jQuery(document).ready(function($) {
    const page = $('html, body');

    // Brands Autocomplete
    const regionSearch = $('input.region-search');
    if (regionSearch.length) {
      regionSearch.each(function() {
        const _this = $(this);
        const clearButton = _this.siblings('.clear-button');

        _this.rsdAutocomplete({
          minimumInputLength: -1,
          maxResults: -1,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 3,
          showListName: false,
        });

        if (_this.val().length === 0) {
          clearButton.hide();
        }

        clearButton.on('click', function() {
          _this.val('');
          _this.trigger('input');
        });
      });

      regionSearch.on('click', function() {
        if (helpers.isMobile()) {
          page.on('scroll mousewheel touchmove', function() {
            page.stop();
          });

          page.animate({scrollTop: $(this).offset().top}, 'slow', function() {
            page.off('scroll mousewheel touchmove');
          });
        }
      });

      regionSearch.on('input', function() {
        const _this = $(this);
        const clearButton = _this.siblings('.clear-button');

        if (_this.val().length === 0) {
          clearButton.hide();
        } else {
          clearButton.show();
        }

        if (_this.data('cookie-region') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-region'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);
        const clearButton = _this.siblings('.clear-button');

        clearButton.show();

        if (_this.data('cookie-region')) {
          helpers.docCookies.setItem(_this.data('cookie-region'), _this.val(), 1500, '/');
        }
      });
    }
  });
};

export default searchRegions;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchRegion.js